module.exports = {
    // 头部菜单
    header_menu: {
        logout: 'sign out',
        index: '홈페이지',
        game: '게임',
        news: '소식',
        about: '회사연혁',
        JoinUs: '인재채용',
        Join: '인재채용',
    },
    // 标题
    title: {
        gname: '게임',
        gmore: '모든게임 보기',
        nname: '소식',
        nmore: '모든소식 보기'
    },
    //按钮
    btn: {
        explore: '자세히 보기',
        website: '홈페이지 바로가기'
    }
}


// WEBPACK FOOTER //
// ./src/language/kr.js